module.exports = __webpack_public_path__ + "static/media/manufact_c.c641e709.png";